import { useState } from "react";
import { View } from "react-native";
import IconPlus from "src/icons/IconPlus";
import { paddingMedium, paddingSmall } from "src/styles/spacing";
import { Image } from "src/swsh-native";
import { MINI_CARD_UPPER_SECTION_HEIGHT, MINI_CARD_WIDTH } from "../constants";
import { MiniCardProps } from "../types";
import MiniCardTitle from "./MiniCardTitle";

const MiniCardContent = ({
	content,
	title,
	variant,
	EmptyIcon,
	fallbackContent,
}: Pick<MiniCardProps, "content" | "fallbackContent" | "title" | "variant" | "EmptyIcon">) => {
	const [preferFallback, setPreferFallback] = useState(false);
	const activeContent = preferFallback && fallbackContent ? fallbackContent : content;
	if (variant === "Empty") {
		return (
			<View
				style={{
					width: "100%",
					height: "100%",
					flexDirection: "row",
					gap: paddingSmall,
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<IconPlus size={14} />
				{!!EmptyIcon && <EmptyIcon size={28} />}
			</View>
		);
	}
	return (
		<>
			<View
				pointerEvents="none"
				style={{
					width: MINI_CARD_WIDTH,
					minHeight: MINI_CARD_UPPER_SECTION_HEIGHT,
					paddingTop: paddingSmall,
					alignItems: "center",
					justifyContent: activeContent?.variant === "TopImage" ? "flex-start" : "center",
				}}
			>
				{activeContent?.variant === "Image" && (
					<Image
						src={activeContent.src}
						alt={activeContent.alt}
						dim={{
							width: 26,
							height: 20,
						}}
						contentFit="contain"
						onError={() => {
							setPreferFallback(true);
						}}
					/>
				)}
				{activeContent?.variant === "TopImage" && (
					<Image
						src={activeContent.src}
						alt={activeContent.alt}
						contentPosition="top"
						dim={{
							width: MINI_CARD_WIDTH,
							height: MINI_CARD_UPPER_SECTION_HEIGHT - paddingMedium,
						}}
						contentFit="contain"
						onError={() => {
							setPreferFallback(true);
						}}
					/>
				)}
				{activeContent?.variant === "Render" && activeContent.renderContent()}
			</View>
			<MiniCardTitle title={title} />
		</>
	);
};
export default MiniCardContent;
